var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2811 19.5815V12.1835H13.8731L14.2691 9.30354H11.2811V7.46754C11.2811 6.99954 11.3711 6.66354 11.5511 6.45954C11.7791 6.19554 12.1871 6.06354 12.7751 6.06354H14.3771V3.48954C14.1971 3.46554 13.9151 3.44154 13.5311 3.41754C13.0271 3.39354 12.5291 3.38154 12.0371 3.38154C11.2691 3.38154 10.5911 3.52854 10.0031 3.82254C9.41506 4.11654 8.95906 4.54854 8.63506 5.11854C8.31106 5.68854 8.14906 6.37554 8.14906 7.17954V9.30354H5.53906V12.1835H8.14906V19.5815H11.2811Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.19b908d4851f4afb8a3585fde1f787cb.svg";
export { ForwardRef as ReactComponent };